<div #textContent [attr.disabled]="to.disabled" [innerHTML]="html | sanitizeHtml"></div>
